import * as React from "react";
const SvgFiRrBird = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bird_svg__a)">
      <path
        fill="#062147"
        d="m23.311 6.205-1.371-.587C21.508 2.45 18.785.001 15.5.001a6.51 6.51 0 0 0-6.5 6.5v1c0 1.93-1.57 3.5-3.5 3.5S2 9.431 2 7.501v-.5a1 1 0 1 0-2 0v4c0 5.026 3.388 9.275 8 10.584v1.416a1 1 0 1 0 2 0v-1.046a11 11 0 0 0 2 0v1.046a1 1 0 1 0 2 0v-1.416c4.612-1.309 8-5.558 8-10.584V8.858l1.311-.562a1.137 1.137 0 0 0 0-2.091M5.5 13A5.48 5.48 0 0 0 9 11.739v.761C9 14.981 6.981 17 4.5 17h-.202a8.97 8.97 0 0 1-2.265-5.234A5.47 5.47 0 0 0 5.5 13M20 11c0 4.963-4.037 9-9 9a8.95 8.95 0 0 1-4.618-1.278C9.051 17.913 11 15.43 11 12.5v-6C11 4.019 13.019 2 15.5 2S20 4.019 20 6.5zm-2-5.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 18 5.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bird_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBird;
